(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('event', sellers);

    /* @ngInject */
    function sellers($sce) {
        var directive = {
            bindToController: true,
            templateUrl: 'event.tpl',
            controller: eventController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.data.query[0].content = $sce.trustAsHtml(scope.vm.data.query[0].content);
        }

    }

    /* @ngInject */
    function eventController ($scope, $http) {
    }

})();